<template>
  <div class="header">
    <div
      class="fold"
      :class="isCollapse ? 'rotate180' : 'rotate0'"
      @click="fold"
    >
      <i class="el-icon-s-fold"></i>
    </div>
    <div class="right-section">
      <div class="task-center-wrapper">
        <div class="task-center-btn" @click="openTaskCenter">
          <div class="task-icon-wrapper">
            <i class="el-icon-download task-icon"></i>
            <div class="download-progress" :class="{ 'active': taskCount > 0 }"></div>
          </div>
          <span class="task-text">任务中心</span>
          <el-badge :value="taskCount" :hidden="taskCount === 0" class="task-badge"></el-badge>
        </div>
      </div>
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <avue-avatar :src="headPortrait"></avue-avatar>
          <span :style="{ marginLeft: '15px' }">{{ fullName }}</span>
          <i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/"> 首页 </el-dropdown-item>
          <!--                       <el-dropdown-item command="/info/index">-->
          <!--                            个人信息-->
          <!--                       </el-dropdown-item>-->
          <el-dropdown-item command="/info"> 修改个人信息 </el-dropdown-item>
          <el-dropdown-item command="/password"> 修改密码 </el-dropdown-item>
          <el-dropdown-item :divided="true" command="/login">
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <TaskCenter ref="taskCenter" @update-processing-count="updateTaskCount"></TaskCenter>
  </div>
</template>

<script>
import { logout, userinfo } from "../../api";
import { mapActions, mapState } from "vuex";
import TaskCenter from "../../components/TaskCenter/index.vue";

export default {
  name: "header.vue",
  components: {
    TaskCenter,
  },
  props: {
    isCollapse: Boolean,
  },
  data() {
    return {
      headPortrait: this.$store.state.user.userInfo.headPortrait,
      fullName: "",
      taskCount: 0,
      taskCountTimer: null,
    };
  },
  computed: {
    isImg() {
      return this.$store.state.user.userInfo.headPortrait;
    },
    isName() {
      return this.$store.state.user.userInfo.fullName;
    },
  },
  watch: {
    isImg(newName, oldName) {
      // console.log(newName,oldName, "newNamenewName");
      this.headPortrait = newName;
    },
    isName(newName, oldName) {
      // console.log(newName,oldName, "newNamenewName");
      this.fullName = newName;
    },
    immediate: true,
    // deep: true,
  },
  created() {
    //   this.allButton('request');
  },
  mounted() {
    userinfo()
      .then((res) => {
        if (res.code === 200) {
          this.headPortrait = res.data.headPortrait;
          this.fullName = res.data.fullName;
          this.$store.commit("setUserInfo", res.data);
        }
      })
      .catch((err) => {
        // this.$message.error(err.msg)
      });

    this.$root.eventHub.$on("changeUserInfo", (n) => {
      this.headPortrait = this.$store.state.user.userInfo.headPortrait;
    });
    
    this.$root.eventHub.$on("openTaskCenter", () => {
      this.openTaskCenter();
    });
    
    // 初始化任务处理数量
    this.updateTaskCountFromTaskCenter();
    
    // 如果有处理中的任务，启动定时器
    if (this.taskCount > 0) {
      this.startTaskCountTimer();
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.taskCountTimer) {
      clearInterval(this.taskCountTimer);
    }
  },
  methods: {
    ...mapActions(["allButton"]),
    fold() {
      this.$root.eventHub.$emit("changeDate", null);
    },
    openTaskCenter() {
      this.$refs.taskCenter.open();
    },
    updateTaskCount(count) {
      const oldCount = this.taskCount;
      this.taskCount = count;
      
      // 当任务数量从0变为大于0时，重新启动定时器
      if (oldCount === 0 && count > 0 && !this.taskCountTimer) {
        this.startTaskCountTimer();
      }
      // 当任务数量为0时，检查是否需要停止定时器
      else if (count === 0) {
        this.checkAndStopTimer();
      }
    },
    // 启动任务数量定时器
    startTaskCountTimer() {
      // 如果已存在定时器，先清理
      if (this.taskCountTimer) {
        clearInterval(this.taskCountTimer);
      }
      
      // 设置定时器，每30秒更新一次任务数量
      this.taskCountTimer = setInterval(() => {
        // 只有当有处理中的任务时才更新
        if (this.taskCount > 0) {
          this.updateTaskCountFromTaskCenter();
        }
      }, 30000);
    },
    updateTaskCountFromTaskCenter() {
      // 如果任务中心组件已存在，获取处理中的任务数量
      if (this.$refs.taskCenter) {
        this.$refs.taskCenter.fetchData();
      }
    },
    // 检查是否需要停止定时器
    checkAndStopTimer() {
      if (this.taskCount === 0 && this.taskCountTimer) {
        clearInterval(this.taskCountTimer);
        this.taskCountTimer = null;
      }
    },
    handleCommand(command) {
      if (command == "/login") {
        this.$confirm(`退出系统, 是否继续?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback: (action) => {
            if (action == "confirm") {
              logout()
                .then((res) => {
                  if (res.code === 200) {
                    this.$router.push("/login");
                    this.global.Set_store();
                    this.global.SET_localStorage();
                  }
                })
                .catch((err) => {
                  this.$message.error(err.msg);
                });
            } else {
              this.$message({
                type: "info",
                message: "已取消",
              });
            }
          },
        });
      } else {
        if (command != this.$store.state.index.router) {
          this.$router.push(command);
          let title = "";
          if (command == "/") {
            title = "数据统计";
          } else if (command == "/info") {
            title = "修改个人信息";
          } else {
            title = "修改密码";
          }
          let data = {
            title: title,
            name: "-1",
            url: command,
            index: "0",
          };
          if (command == "/") {
            data = {
              title: title,
              name: "0",
              url: command,
              index: "1-1",
            };
                 let exist = false;
          let tableTabs = this.$store.state.index.tableTabs;
          tableTabs.forEach((item) => {
            if (item.title == title) {
              data.name = item.name;
              exist = true;
            }
          });
          if (!exist) {
            tableTabs.forEach((item, index) => {
              if (index + 1 == tableTabs.length) {
                data.name = (item.name * 1 + 1).toString();
              }
            });
          }
          this.$root.eventHub.$emit("changeSubMenuIndex", "1-1");
          this.$root.eventHub.$emit("changeTableTabs", { type: exist, data });
          } else {
                 let exist = false;
          let tableTabs = this.$store.state.index.tableTabs;
          tableTabs.forEach((item) => {
            if (item.title == title) {
              data.name = item.name;
              exist = true;
            }
          });
          if (!exist) {
            tableTabs.forEach((item, index) => {
              if (index + 1 == tableTabs.length) {
                data.name = (item.name * 1 + 1).toString();
              }
            });
          }
          this.$root.eventHub.$emit("changeSubMenuIndex", "");
          this.$root.eventHub.$emit("changeTableTabs", { type: exist, data });
          }

     
        }
      }
    },
  },
};
</script>

<style scoped>
.header {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
.fold {
  font-size: 30px;
}
.right-section {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.task-center-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 10px;
}
.task-center-btn {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.task-center-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}
.task-center-btn:hover::before {
  left: 100%;
}
.task-center-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.task-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
}

.task-icon {
  font-size: 20px;
  transition: all 0.3s ease;
  z-index: 2;
  position: relative;
}

.download-progress {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top: 2px solid #00D8C3;
  opacity: 0;
  transition: all 0.3s ease;
  z-index: 1;
  box-shadow: 0 0 6px rgba(0, 216, 195, 0.3);
}

.download-progress.active {
  opacity: 1;
  animation: spinProgress 1.5s linear infinite;
  box-shadow: 0 0 10px rgba(0, 216, 195, 0.6);
}

/* 当任务中心按钮被点击时暂停动画，避免干扰 */
.task-center-btn:active .download-progress.active {
  animation-play-state: paused;
}
.task-text {
  font-size: 15px;
  font-weight: 500;
  margin-left: 5px;
}

@keyframes spinProgress {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
    border-top-color: #00D8C3;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }
  25% {
    border-top-color: #00D8C3;
    border-right-color: #00D8C3;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }
  50% {
    border-top-color: #00D8C3;
    border-right-color: #00D8C3;
    border-bottom-color: #00D8C3;
    border-left-color: transparent;
  }
  75% {
    border-top-color: #00D8C3;
    border-right-color: #00D8C3;
    border-bottom-color: #00D8C3;
    border-left-color: #00D8C3;
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
    border-top-color: #00D8C3;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-left-color: transparent;
  }
}
.task-badge {
  position: relative;
  top: -6px;
  right: 0;
}
.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.rotate180 {
  transition: 0.5s;
  transform: rotate(180deg);
}
.rotate0 {
  transition: 0.5s;
  transform: rotate(0deg);
}
.el-icon--right {
  margin-left: 20px;
}
</style>
